import { render, staticRenderFns } from "./SubjectNameTags.vue?vue&type=template&id=b2324eb2&"
import script from "./SubjectNameTags.vue?vue&type=script&lang=js&"
export * from "./SubjectNameTags.vue?vue&type=script&lang=js&"
import style0 from "./SubjectNameTags.vue?vue&type=style&index=0&id=b2324eb2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports